
const API_VAR="http://localhost:5050/api";

export const HOST='http://localhost:3000';

export const addtask =`${API_VAR}/tasks`;
export const getTask =`${API_VAR}/getTask`;
export const deleteTask =`${API_VAR}/deleteTask`;
export  const updateTask =`${API_VAR}/updateTask`;

export  const getSharedTask =`${API_VAR}/getSharedTask`;
export  const getAllTasks =`${API_VAR}/getAllTasks`;

// export const userRegister =`${API_VAR}/userRoute/register`;


export const setting =`${API_VAR}/setting`;
export const defaultSetting =`${API_VAR}/defaultSetting`;
export const settingShare =`${API_VAR}/setting/share`;
export const getSetting = `${API_VAR}/getSetting`
export const deleteMail = `${API_VAR}/deleteMail`